import { Component, Input, OnChanges } from '@angular/core'

import { Antecipacao } from '../../../pkw-data/collect/extrato/antecipacao.model'
import { Agrupamento } from '../../../pkw-data/collect/extrato/agrupamento.model'

@Component({
  selector: 'col-detalhe-antecipacoes-estabelecimento',
  templateUrl: './detalhe-antecipacoes-estabelecimento.component.html',
  styleUrls: ['../../extratos.component.scss']
})
export class DetalheAntecipacoesEstabelecimentoComponent implements OnChanges {
  @Input() agrupamento: Agrupamento<Antecipacao>

  maisDetalhesExpandido: boolean[]

  constructor() {}

  ngOnChanges() {
      if (this.agrupamento) {
          this.maisDetalhesExpandido = new Array(this.agrupamento.detalhes.length)
          this.maisDetalhesExpandido.fill(false)
      }
  }

  toggleCollapse(index: number, icon: HTMLSpanElement) {
      this.maisDetalhesExpandido[index] = !this.maisDetalhesExpandido[index]

      icon.classList.toggle('fa-chevron-right')
      icon.classList.toggle('fa-chevron-down')
  }

}



// WEBPACK FOOTER //
// ./src/app/extratos/extratos-de-antecipacoes/detalhe-antecipacoes-estabelecimento/detalhe-antecipacoes-estabelecimento.component.ts